export default {
  routes: [
    {
      name: 'factors',
      path: '/directory/factors',
      component: () => import('./views/TheFactors.vue'),

    },

    {
      name: 'factor',
      path: '/directory/factors/:uuid',
      component: () => import('./views/TheFactor.vue'),
    },
  ]
}
